export default __webpack_public_path__ + "static/media/Kanipakam-slider-01@2x.a033402e.png";